const configured = process.env.REACT_APP_API_BASE || "http://localhost:5000";
export const API_ORIGIN = String(configured).replace(/\/+$/, "");
export const apiUrl = (path = "") => API_ORIGIN + path;
